var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-currency-wrapper",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.prepend ? _c('span', {
    staticClass: "prepend"
  }, [_vm._v(_vm._s(_vm.prepend))]) : _vm._e(), _c('input', {
    staticClass: "custom-number-input",
    class: {
      'has-append': _vm.append
    },
    style: _vm.inputStyle,
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "input": function input($event) {
        return _vm.onInput($event.target.value);
      },
      "blur": _vm.formatOnBlur,
      "keydown": _vm.onKeydown
    }
  }), _vm.append ? _c('span', {
    staticClass: "append"
  }, [_vm._v(_vm._s(_vm.append))]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }